import React, { Component, Fragment } from 'react';
import Modal from 'components/Modal';
import HashLink from 'components/HashLink';
import ModalAndroid from 'components/ModalAndroid';
import integratedCharts from './images/integrated-charts.png';
import globalMarket from './images/global-market.png';
import stayInLoop from './images/stay-in-loop.png';
import service from './images/service.png';
import apple from './images/apple.png';
import android from './images/android.png';
import free_icon from './images/free_icon.png';
import spot_icon from './images/spot_icon.png';
import share_icon from './images/share_icon.png';
import service_icon from './images/service_icon.png';
import './style.scss';

class HomeContent extends Component {
    channelNode: HTMLDivElement;

    componentDidMount() {
        const hash = window.location.hash;

        if (hash.includes('download')) {
            this.scrollToAnchor();
        }
    }

    scrollToAnchor = () => {
        if (this.channelNode) {
            this.channelNode.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    };

    channel = node => {
        this.channelNode = node;
    };

    handleAndroid = e => {
        e.preventDefault();

        return Modal.open({
            component: <ModalAndroid />
        });
    };

    render() {
        return (
            <Fragment>
                <div className="section free">
                    <div className="aninode site-main">
                        <div className="graph">
                            <img
                                src={integratedCharts}
                                data-animation="a-flyLeftIn"
                                title="integratedCharts"
                                alt="integratedCharts"
                                className="mockup-pic"
                            />
                        </div>
                        <div className="des">
                            <div className="des-container">
                                <img
                                    src={free_icon}
                                    data-animation="a-flyRightIn"
                                    alt="free_icon"
                                    title="free"
                                    className="icon"
                                />
                                <h2 className="title" data-animation="a-flyRightIn">
                                    Leading-Edge Mobile Trading
                                </h2>
                            </div>
                            <p className="tit">Tools for both new and experienced investors. </p>
                            <p className="tit-explain">
                                $0.00 commission applies to online U.S. equity trades and exchange-traded funds (ETFs)
                                in a TradeUP retail account only for TradeUP Securities, Inc. retail clients. Sell
                                orders are subject to an activity assessment fee. Other exclusions and conditions may
                                apply. See{' '}
                                <a href="https://www.tradeup.com/pricing/commissions-us">
                                    https://www.tradeup.com/pricing/commissions-us
                                </a>{' '}
                                for details. Institutional accounts, OTC securities trading and other types of
                                high-touch services are subject to different commission schedules.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="section free">
                    <div className="aninode site-main site-main-right">
                        <div className="graph graph-right">
                            <div className="des-container">
                                <img
                                    src={spot_icon}
                                    data-animation="a-flyLeftIn"
                                    alt="free_icon"
                                    title="free"
                                    className="icon"
                                />
                                <h2 className="title" data-animation="a-flyLeftIn">
                                    Real-Time Global Market Data
                                </h2>
                            </div>
                            <p className="tit" data-animation="a-flyLeftIn">
                                Enjoy a full range of real-time market data across the world and free of charge.
                            </p>
                        </div>
                        <div className="des des-right">
                            <img
                                src={globalMarket}
                                data-animation="a-flyRightIn"
                                alt="globalMarket"
                                title="globalMarket"
                                className="mockup-pic"
                            />
                        </div>
                    </div>
                </div>
                <div className="section free">
                    <div className="aninode site-main">
                        <div className="graph">
                            <img
                                src={stayInLoop}
                                data-animation="a-flyLeftIn"
                                alt="stayInLoop"
                                title="stayInLoop"
                                className="mockup-pic"
                            />
                        </div>
                        <div className="des">
                            <div className="des-container">
                                <img
                                    src={share_icon}
                                    data-animation="a-flyRightIn"
                                    alt="share_icon"
                                    title="share"
                                    className="icon share-icon"
                                />
                                <h2 className="title" data-animation="a-flyRightIn">
                                    Insights and Inspiration
                                </h2>
                            </div>
                            <p className="tit" data-animation="a-flyRightIn">
                                Capture market opportunities with extensive research and analytical tools.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="section channel" ref={this.channel} id="channel">
                    <div className="aninode site-main">
                        <h2 className="channel-title" data-animation="a-flyTopIn">
                            Tools for both new
                            <br />
                            and experienced investors
                        </h2>
                        <p className="des" data-animation="a-flyTopIn">
                            In-depth analytics, screeners, and candlestick charts help experienced
                            <br />
                            traders stay on top of the market.
                        </p>
                        <div className="btn-box">
                            <a
                                className="ios btn"
                                href="https://apps.apple.com/app/tradeup-international/id1492602577"
                                target="view_window">
                                <img src={apple} alt="apple" title="apple" />
                                iOS
                            </a>
                            {/* 正式链接可能会被下架或者失效，这里先用临时的下载方案解决 --> */}
                            {/* https://play.google.com/store/apps/details?id=com.tigerbrokers.tigertradeintl&hl=en  */}
                            <HashLink className="android btn" onClick={this.handleAndroid}>
                                <img src={android} alt="android" title="android" />
                                Android
                            </HashLink>
                        </div>
                    </div>
                </div>
                <div className="section free">
                    <div className="aninode site-main">
                        <div className="graph">
                            <img
                                src={service}
                                data-animation="a-flyLeftIn"
                                title="mockup"
                                alt="mockup"
                                className="service-pic"
                            />
                        </div>
                        <div className="des">
                            <div className="des-container">
                                <img
                                    src={service_icon}
                                    data-animation="a-flyRightIn"
                                    alt="service_icon"
                                    title="service"
                                    className="icon service-icon"
                                />
                                <h2 className="title" data-animation="a-flyRightIn">
                                    One Stop Customer
                                    <br />
                                    Service
                                </h2>
                            </div>
                            <p className="tit" data-animation="a-flyRightIn">
                                Customer service is available through live chat or email for one-on-one support.
                            </p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default HomeContent;
